/* eslint-disable react/jsx-key */
import * as React from 'react';
import {
  IconChildPlayground16,
  IconCommercialObject16,
  IconPet16,
  IconFastService16,
  IconFitness16,
  IconKid16,
  IconOffice16,
  IconHospital16,
  IconPool16,
  IconRestaurant16,
  IconSchool16,
  IconSpa16,
  IconSportsground16,
  IconSupermarket16,
} from '@cian/ui-kit/icons';

import { EInfrastructureType } from '../../../../../../types/offer';

export const INFRASTRUCTURE_ICONS_MAP = new Map<EInfrastructureType, React.ReactNode>([
  [EInfrastructureType.Children, <IconChildPlayground16 />],
  [EInfrastructureType.Commerce, <IconCommercialObject16 />],
  [EInfrastructureType.Dogs, <IconPet16 />],
  [EInfrastructureType.Domestic, <IconFastService16 />],
  [EInfrastructureType.Fitness, <IconFitness16 />],
  [EInfrastructureType.Kindergarten, <IconKid16 />],
  [EInfrastructureType.Offices, <IconOffice16 />],
  [EInfrastructureType.Polyclinic, <IconHospital16 />],
  [EInfrastructureType.Pool, <IconPool16 />],
  [EInfrastructureType.Recreation, <IconChildPlayground16 />],
  [EInfrastructureType.Restaurant, <IconRestaurant16 />],
  [EInfrastructureType.School, <IconSchool16 />],
  [EInfrastructureType.Spa, <IconSpa16 />],
  [EInfrastructureType.Sport, <IconSportsground16 />],
  [EInfrastructureType.Supermarket, <IconSupermarket16 />],
]);
